import React from 'react';
import styled from 'styled-components';

import { DateInputV4 as DateInputComponent } from 'wg-fe-ui';

const DateInput: React.FC<
  React.PropsWithChildren<typeof DateInputComponent>
> = (props) => {
  return <StyledDateInput {...props} />;
};

const StyledDateInput = styled(DateInputComponent)`
  width: 100%;
  height: auto;
  min-height: 44px;
  > label > div {
    /* Input box */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
      0 0 1px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    height: 4.5rem;

    ${({ prefilled }) =>
      prefilled ? `border-color: #FFBC0F; background-color: #FFF9EA;` : ''}
  }

  > div {
    height: unset;
    margin-top: 1.6rem;
    margin-bottom: 0;

    > p {
      font-size: 14px;
    }
  }
`;

export default DateInput;
